/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { wsResponse } from '../common/socket/SocketHandler';

const initialState = {
  connected: false,
  lastMessageAt: 0,
  lastMessage: null as wsResponse | null,
};

export type WebSocketState = typeof initialState;

export const webSocket = createSlice({
  name: 'webSocket',
  initialState,
  reducers: {
    onMessage(state, { payload }: PayloadAction<wsResponse>) {
      state.lastMessageAt = Date.now();
      state.lastMessage = payload;
    },
    changeConnected(state, { payload }: PayloadAction<boolean>) {
      state.connected = payload;
    },
  },
});
